const breakPoint = {
    maxWidth: 1024,
    mediumWidth: 768,
};

export default breakPoint;
